import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Checkbox = React.forwardRef(function Checkbox2({ className, indeterminate = false, onCheckedChange, ...props }, forwardedRef) {
  const innerRef = React.useRef(null);
  React.useEffect(() => {
    if (innerRef.current) innerRef.current.indeterminate = indeterminate;
  }, [indeterminate]);
  const setRefs = React.useCallback(
    (node) => {
      innerRef.current = node;
      if (typeof forwardedRef === "function") forwardedRef(node);
      else if (forwardedRef) forwardedRef.current = node;
    },
    [forwardedRef]
  );
  return /* @__PURE__ */ jsx(
    "input",
    {
      ref: setRefs,
      type: "checkbox",
      className: cn(
        "size-4 shrink-0 cursor-pointer rounded-sm border border-input accent-brand disabled:cursor-not-allowed disabled:opacity-50 focus-ring",
        className
      ),
      onChange: (e) => onCheckedChange?.(e.target.checked),
      ...props
    }
  );
});

export { Checkbox };
//# sourceMappingURL=chunk-IW2JHXYK.js.map
//# sourceMappingURL=chunk-IW2JHXYK.js.map